export * from './produto-gerar-codigo-de-barras.component';